import { LlmChatService, LlmHistoryMenuController, LlmHistoryNode } from '@adaptiva/ai/common';
import { IChatMessage } from '@adaptiva/core/chat';
import { AdaColor, BaseThemeService, IThemeModel } from '@adaptiva/core/themes';
import { ChatComponent } from '@adaptiva/widgets/chat';
import { InlineMenuComponent } from '@adaptiva/widgets/inline-menu';
import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';

@Component({
	selector: 'ada-llm-history-node-detail',
	templateUrl: './llm-history-node-detail.component.html',
	styleUrl: './llm-history-node-detail.component.scss',
	imports: [
		ChatComponent,
		InlineMenuComponent,
	],
	providers: [LlmHistoryMenuController],
	host: {
		'[class.ada-full-height]': 'true',
		'[class.ada-overflowY-auto]': 'true',
		'[class.ada-position-relative]': 'true',
	}
})
export class LlmHistoryNodeDetailComponent {

	public readonly node: InputSignal<LlmHistoryNode> = input();

	protected readonly chatService: LlmChatService = inject(LlmChatService);

	protected readonly menuController: LlmHistoryMenuController = inject(LlmHistoryMenuController);

	protected readonly themes: BaseThemeService = inject(BaseThemeService);

	protected readonly menuTextColor: Signal<string> = computed(() => {
		const _theme: IThemeModel = this.themes.theme();

		return AdaColor.fromRgb(_theme.foregroundColor).toString();
	});

	public readonly nodeMessages: Signal<IChatMessage[]> = computed(() => {
		return this.chatService.nodeMessages(this.node());
	});

}
